import { useBookingConfirmationSummary, useGetBookingSession } from '@massilia/queries'
import { createFileRoute } from '@tanstack/react-router'

import { CheckoutComponent } from '@/components/checkout/checkout-component'
import { bookingSessionSearchSchema } from '@/lib/schemas/booking-session-search.schema'

export const Route = createFileRoute('/_booking/checkout')({
  component: CheckoutRouteComponent,
  validateSearch: bookingSessionSearchSchema,
})

function CheckoutRouteComponent() {
  const { session: sessionId } = Route.useSearch()
  const { data: session, isLoading: isSessionLoading } = useGetBookingSession(sessionId, {
    throwOnError: true,
  })

  // On retry (PAYMENT_INITIATED), fetch the booking summary to prefill email/phone
  const isRetry = session?.step === 'PAYMENT_INITIATED'
  const { data: summary, isLoading: isSummaryLoading } = useBookingConfirmationSummary(
    isRetry ? sessionId : undefined
  )

  const isLoading = isSessionLoading || (isRetry && isSummaryLoading)

  return (
    <CheckoutComponent
      isLoading={isLoading}
      prefillEmail={summary?.client.email ?? undefined}
      prefillPhone={session?.buyerPhone ?? summary?.client.phone ?? undefined}
      session={session}
      sessionId={sessionId}
    />
  )
}
